import ModalFormJobTitle from "./ModalFormJobTitle";

export default ModalFormJobTitle;
